import Checkbox from './Checkbox';
import CheckboxGroup from './CheckboxGroup';
import CheckboxSimple from './CheckboxSimple';
import CheckboxSwitch, { Switch } from './Switch';
import TermsOfServiceCheckbox from './TermsOfServiceCheckbox';
import MarketingOptInCheckbox from './MarketingOptInCheckbox';

export default Checkbox;
export {
  CheckboxGroup,
  CheckboxSimple,
  CheckboxSwitch,
  Switch,
  TermsOfServiceCheckbox,
  MarketingOptInCheckbox,
};
